/**
 * The shell's one ambient wash (ui-ux.md §2 "Ambient wash"): fixed behind
 * `<main>` from the rail's edge, painted from `--ambient`, which a title-led
 * view sets with `useAmbient()` (src/lib/ambient.ts). Unset → transparent.
 * All styling is `.ambient-stage` in index.css (registered `--ambient-wash`
 * so a title change cross-fades over 600ms).
 */
export function AmbientStage() {
  return <div aria-hidden className="ambient-stage" />;
}
